const accordionData = [
  {
    question: "HOW CAN I JOIN FITNESS CLASSES?",
    answer:
      "To join our fitness classes, simply choose a membership plan that suits your needs. For first-time visitors, we offer a free trial class every Saturday. Check our schedule and sign up through the website or at the reception desk.",
  },
  {
    question: "WHAT FITNESS PROGRAM IS BEST FOR BEGINNERS?",
    answer:
      "If you're new to fitness, we recommend starting with our introductory courses or personal training sessions. Additionally, you can take a free physical assessment to tailor the best program for your fitness level and goals.",
  },
  {
    question: "WHAT IS THE MINIMUM AGE FOR GYM MEMBERSHIP?",
    answer:
      "Our standard membership is available for individuals aged 18 and above. However, we offer specialized youth programs for teenagers aged 13-17 and group activities for children. Contact us for more details on these categories.",
  },
  {
    question: "CAN I INVITE FRIENDS TO TRY FITNESSGYM?",
    answer:
      "Yes! You can bring a friend for a trial session, and if they join, you’ll receive a discount on your next membership renewal. We believe fitness is more fun with friends!",
  },
  {
    question: "WHAT PAYMENT METHODS ARE ACCEPTED?",
    answer:
      "We accept Visa, MasterCard, and PayPal for online payments. Cash payments can be made at the gym. For group packages and memberships, card payments are preferred for convenience.",
  },
  {
    question: "CAN I PAUSE MY MEMBERSHIP?",
    answer:
      "Yes, you can freeze your membership for up to 12 months. During this period, all benefits will be preserved. You’ll receive reminders when your freeze period is nearing its end.",
  },
];

export default accordionData;
